export const AUTH_LOCAL_STORAGE: string = "iseeTokens";

// This will give localStorage data without decode of tokens
export const getTokenLocalStorage = (): any => {
  if (typeof window === "undefined") {
    return null;
  }
  const value = localStorage.getItem(AUTH_LOCAL_STORAGE);
  if (!value) return null;
  const parsed: any = JSON.parse(value);
  return parsed;
};

export const removeLocalStorage = (): void => {
  localStorage.removeItem(AUTH_LOCAL_STORAGE);
  localStorage.clear();
  sessionStorage.clear();
}; 